<div ngClass="p-t-l p-r-l">
	<button mat-icon-button class="close-button" (click)="onCloseClick()">
		<mat-icon>close</mat-icon>
	</button>
</div>
<div ngClass="m-l-xl" fxLayout="row" fxLayoutAlign="baseline">
	<h2 i18n="@@createUpdate_title">Create Update</h2>
	<div ngClass="p-l-m">
		<mat-spinner *ngIf="loadingText" diameter="16" color="accent"></mat-spinner>
	</div>
</div>
<mat-dialog-content class="mat-typography">
	<!-- <h3>Original language</h3> -->
	<div ngClass="m-l-xs" fxLayout="row" fxLayoutAlign="start center">
		<mat-label
			class="mat-subtitle-2"
			i18n="@@createUpdate_originalLanguage_title"
			>Original Language</mat-label
		>
		<div fxLayout="row" ngClass="p-xs" fxLayoutAlign="start center">
			<img
				width="20px"
				src="{{ languageIconPath + originalLocale + '1/public' }}"
			/>&nbsp;
			<span>{{ allLanguages[originalLocale] }}</span>
		</div>
	</div>
	<br />
	<app-quill-editor
		[quillContent]="data.update?.content"
		(onContentChange)="changeUpdateContent($event)"
		(allTextCheck)="allCheck($event)"
		(pasteDetected)="handlePasteDetected($event)"
	>
	</app-quill-editor>
	<div ngClass="m-r-xs" fxLayoutAlign="end end">
		<mat-error
			*ngIf="!isContentValidFlag"
			i18n="@@createUpdate_invalidOrEmpty_Content_error"
			>Content is invalid or empty</mat-error
		>
	</div>
	<div
		ngClass="m-l-xs"
		fxLayout="row wrap"
		fxLayoutAlign="start center"
		fxLayoutGap="16px"
		(click)="isContentValid()"
	>
		<fieldset class="disable" [disabled]="newUpdate?.content?.length < 1">
			<app-fundraiser-media-edit
				[matTooltip]="updateMediaTooltip"
				[fundraiserMediaList]="data.update?.mediaList"
				(onMediaChange)="changeUpdateMedia($event)"
			>
			</app-fundraiser-media-edit>
		</fieldset>
	</div>
</mat-dialog-content>
<div ngClass="m-t-m">
	<mat-dialog-actions align="end">
		<button
			[disabled]="
				!(newUpdate.content || newUpdate.imageList) ||
				isLoading ||
				!this.allTextCheck
			"
			mat-flat-button
			color="accent"
			id="addUpdatesFundraiserPageCreateButton"
			(click)="createUpdateContentAndMedia()"
		>
			<span i18n="@@button_create">create</span>
			<mat-icon *ngIf="isLoading" ngClass="m-l-xs">
				<mat-spinner color="accent" diameter="16" i18n="@@createUpdate_spinner">
				</mat-spinner>
			</mat-icon>
		</button>
	</mat-dialog-actions>
</div>
